<template>
  <div>
    <v-dialog v-model="bookingAreaProductsDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="green white--text">{{ $t('product.edit_product') }}</v-card-title>
        <v-card-text class="py-5">
          <span>{{ $t('product.select_product') }}</span>
          <v-autocomplete
            color
            v-model="products"
            :items="getProductNameOnly"
            :label="$t('product.title')"
            item-text="name"
            item-value="form"
            solo
            flat
            multiple
            return-object
            background-color="grey lighten-4"
          >
            <template v-slot:append-outer>
              <v-icon v-if="admin || (employee && employee.enableAddProduct)" @click="isProduct = true">mdi-plus</v-icon>
              <v-tooltip v-else top>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-icon disabled>mdi-plus</v-icon>
                  </div>
                </template>
                <span>{{ $t('product.no_permission_to_add_product') }}</span>
              </v-tooltip>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="bookingAreaProductsDialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            @click="saveProducts"
            :disabled="this.products.length < 1"
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <form-product v-model="isProduct" @onLoad="loadInit" :event="`create`"></form-product>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormProduct from "./FormProduct.vue";
export default {
  components: { FormProduct },
  name: "FormAreaProduct",
  computed: {
    ...mapGetters({
      vacancyAreas: "area/getVacancyAreas",
      getProducts: "product/getProducts",
      getProductNameOnly: "product/getProductNameOnly"
    }),
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.$store.getters["markets/getMarketId"]);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.$store.getters["markets/getMarketId"]);
    },
    bookingAreaProductsDialog: {
      get() {
        if (
          this.formData &&
          this.formData.products &&
          this.formData.products.length&&
          this.value
        ) {
          this.products = this.formData.products;
        }else{
          this.products = []
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      products: [],
      isProduct: false
    };
  },
  props: {
    value: Boolean,
    formData: Object
  },
  methods: {
    async loadInit() {
      await this.$store.dispatch("area/getVacancyAreas");
      await this.$store.dispatch("product/getProducts", {
        projectId: this.$route.params.projectId
          ? this.$route.params.projectId
          : this.$store.getters["markets/getProjectId"]
      });
    },
    saveProducts() {
      this.$emit("onSave", this.products);
    }
  }
};
</script>

<style lang="scss" scoped></style>
